<template>
  <v-sheet height="100%">
    <slide4 />
    <v-dialog
      v-model="modalBoolean"
      width="85%"
      style="min-height: 50% !important;"
    >
      <v-card>
        <v-app-bar dark color="primary" :fixed="true">
          <v-spacer></v-spacer>
          <v-btn icon dark @click="modalBoolean = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-app-bar>
        <v-container>
          <v-row>
            <v-col cols="12" class="text-center">
              <iframe
                v-if="clickedItem.name === 'TV' && modalBoolean"
                height="540"
                style="width: inherit;"
                src="https://www.youtube.com/embed/cxLSpOa3Xp8"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              >
              </iframe>
              <template v-else-if="clickedItem.assets">
                <v-img
                  v-for="asset in clickedItem.assets"
                  :key="asset"
                  :src="renderImage(asset)"
                  eager
                >
                </v-img>
              </template>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-sheet>
</template>

<script>
import slide4 from "../../public/static/Slide 4/ROW.svg";
import svgMixin from "@/mixins/svgMixin.js";

export default {
  name: "RightOfWay",
  components: {
    slide4
  },
  mixins: [svgMixin(5, ".slide4", "slide4.js")],
  data() {
    return {
      modalBoolean: false,
      clickedItem: ""
    };
  }
};
</script>

<style>
.mouse {
  cursor: pointer;
}
</style>
